export default __webpack_public_path__ + "static/media/logo.5b92f75b.png";